export default __webpack_public_path__ + "static/media/Background_00139.8db84c13.png";